import React, { PropTypes } from 'react';
import { NitroHeading, NitroSingleSelect } from 'nitro-components';

import { INSIGHTS } from '../../../../routes/const';
import { updateCurrentRole } from '../utils';

const RoleSelector = (
  {
    roles,
    role,
    changeCurrentRole,
    close,
    firstName,
    lastName,
    costCenters,
    displayHeading,
    setGlobalCountryCostCenter,
    setGlobalDynamicFilter
  },
  context
) => {
  const onChange = selectedRole => {
    updateCurrentRole(
      roles,
      costCenters,
      selectedRole.value,
      'ROLESELECTORCHANGE',
      (newRole, costCenter) => {
        changeCurrentRole(newRole);
        setGlobalDynamicFilter([]);
        setGlobalCountryCostCenter(costCenter);
        context.router.push(INSIGHTS);
        close();
      }
    );
  };

  return (
    <div>
      {displayHeading ? (
        <NitroHeading size="1" label={`${firstName} ${lastName}`} />
      ) : null}

      {roles && roles.length > 1 && (
        <section>
          <NitroHeading size="3" label="Viewing data as" />
          <NitroSingleSelect
            value={role.value}
            options={roles}
            mandatory
            bold
            action={onChange}
          />
        </section>
      )}
    </div>
  );
};

RoleSelector.contextTypes = {
  router: PropTypes.shape({})
};

RoleSelector.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.shape({})),
  role: PropTypes.shape({}),
  changeCurrentRole: PropTypes.func,
  close: PropTypes.func,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  displayHeading: PropTypes.bool
};

RoleSelector.defaultProps = {
  displayHeading: true,
  role: null,
  roles: [],
  changeCurrentRole: () => {},
  firstName: '',
  lastName: '',
  close: () => {}
};

export default RoleSelector;



// WEBPACK FOOTER //
// ./src/components/common/Profile/RoleSelector/RoleSelectorComponent.js